import * as XLSX from "xlsx";

export const normalizeHeader = (h) =>
  String(h || "").trim().toLocaleLowerCase("tr-TR").replace(/\./g, "").replace(/\s+/g, " ");

export const pickCell = (row, keys) => {
  for (const k of keys) {
    const val = row?.[k];
    if (val !== undefined && val !== null && String(val).trim() !== "") return val;
  }
  return undefined;
};

export const safeNumber = (v) => (v === undefined || v === null || v === "" ? "" : String(v));

export const parseNumber = (v) => {
  if (v === undefined || v === null || v === "") return undefined;
  const n = Number(String(v).trim().replace(",", "."));
  return Number.isFinite(n) ? n : undefined;
};

export function readExcelFile(file) {
  return new Promise((resolve, reject) => {
    file.arrayBuffer().then((buf) => {
      try {
        const wb = XLSX.read(buf, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        resolve(XLSX.utils.sheet_to_json(ws, { defval: "", raw: false }));
      } catch (e) { reject(e); }
    }).catch(reject);
  });
}

export function downloadExcelTemplate(rows, sheetName, fileName) {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const arr = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([arr], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}
